interface Props {
  nomeArquivo: string
  abas: string[]
  escolhida: string | null
  carregando: boolean
  // Sobrescreve o titulo/descricao padrao (escritos pensando em produtos) --
  // usado pela importacao de aliquotas fiscais, cujas abas nao tem "codigo,
  // descricao e preco" nenhum.
  titulo?: string
  descricao?: string
  aoEscolher: (aba: string) => void
  aoVoltar: () => void
  aoConfirmar: () => void
}

// Escolha da aba da planilha.
//
// 📱 Feita para o CELULAR a 360px: a planilha que deu origem a esta tela tem 28
// abas, entao a lista ROLA dentro da propria caixa (max-h + overflow-y) em vez
// de empurrar o botao "Continuar" para fora do alcance do polegar.
//
// Vocabulario visual copiado de `EscolhaCondicao`: cartao branco com radio,
// borda teal na escolhida, botao teal cheio embaixo, "← Voltar" sublinhado.
export default function EscolhaAba({
  nomeArquivo, abas, escolhida, carregando, titulo, descricao, aoEscolher, aoVoltar, aoConfirmar,
}: Props) {
  return (
    <div className="space-y-3">
      <div className="bg-white rounded-xl shadow-sm p-4 space-y-2">
        <h3 className="text-base font-bold text-slate-800">
          {titulo ?? 'De qual aba da planilha eu leio os produtos?'}
        </h3>
        <p className="text-sm text-slate-600">
          {descricao ?? `«${nomeArquivo}» tem ${abas.length} abas. Toque na que tem a lista de produtos com código, descrição e preço.`}
        </p>
      </div>

      <div className="max-h-[55vh] overflow-y-auto space-y-2 -mx-1 px-1">
        {abas.map((aba) => (
          <label
            key={aba}
            className={`flex items-center gap-3 bg-white rounded-xl shadow-sm p-4 cursor-pointer border-2 ${
              escolhida === aba ? 'border-teal-600' : 'border-transparent'
            }`}
          >
            <input
              type="radio"
              name="aba"
              checked={escolhida === aba}
              onChange={() => aoEscolher(aba)}
              disabled={carregando}
            />
            {/* break-all: nome de aba do Excel pode ser longo e sem espaco, e a
                360px isso estouraria a largura do cartao */}
            <span className="text-sm font-medium text-slate-800 break-all">{aba}</span>
          </label>
        ))}
      </div>

      <button
        onClick={aoConfirmar}
        disabled={escolhida === null || carregando}
        className="w-full bg-teal-700 text-white rounded-lg py-2 font-medium disabled:opacity-50"
      >
        {carregando ? 'Lendo a aba…' : 'Continuar'}
      </button>
      <button
        type="button"
        onClick={aoVoltar}
        disabled={carregando}
        className="w-full text-slate-600 text-sm underline py-2 disabled:opacity-50"
      >
        ← Escolher outro arquivo
      </button>
    </div>
  )
}
